import React, { useEffect, useRef, useState } from 'react';
import { Editor } from '@tinymce/tinymce-react';
const TinyMCEEditor = ({ value, onChange }) => {
    const editorRef = useRef(null);
    const [editorContent, setEditorContent] = useState(value); // Maintain local state
    // Update local state when parent value changes (useful when resetting)
    useEffect(() => {
        if (editorContent !== value) {
            setEditorContent(value);
        }
    }, [value]);
    return (React.createElement(Editor, { tinymceScriptSrc: "/email-builder-js/tinymce/tinymce.min.js", onInit: (evt, editor) => (editorRef.current = editor), value: editorContent, onEditorChange: (newContent) => {
            setEditorContent(newContent); // Update local state first
            onChange(newContent); // Update parent state
        }, init: {
            menubar: false,
            plugins: 'lists link image code fullscreen',
            toolbar: 'bold italic | bullist numlist | link | code fullscreen',
            height: 400,
            content_css: '/email-builder-js/tinymce/skins/ui/oxide/content.min.css',
            branding: false,
            promotion: false,
            base_url: '/email-builder-js/tinymce',
        } }));
};
export default TinyMCEEditor;
//# sourceMappingURL=tinymce.js.map